const STRUCTURE_CHANGING_LABELS = new Set([
    'Terminal Replace',
    'Fragment Grow',
    'Search Nearby',
    'Generated',
    'Sample compound',
    'Grown',
    'Modified',
]);

function changesStructure(label) {
    return STRUCTURE_CHANGING_LABELS.has(label)
        || label.startsWith('Generated by ')
        || label.startsWith('Modified via ');
}

/**
 * Return whether the current compound still represents a docked pose.
 *
 * Heritage is ordered from oldest to newest. Child compounds inherit their
 * parent's history, so a Docked label is valid only until a later operation
 * changes the molecular structure. Pose-preserving operations such as rename,
 * duplicate, and minimization intentionally leave the docked state intact.
 */
export function hasCurrentDockedPose(labels) {
    if (!Array.isArray(labels)) return false;
    let docked = false;
    labels.forEach((label) => {
        if (label === 'Docked') {
            docked = true;
        } else if (typeof label === 'string' && changesStructure(label)) {
            docked = false;
        }
    });
    return docked;
}
